import { combineReducers } from "redux";
import app from "../data/app/AppReducer.js"
import appointment from "../data/appointment/AppointmentReducer.js"
import classes from "../data/classes/ClassReducer.js"
import client from "../data/client/ClientReducer.js"
import employee from "../data/employee/EmployeeReducer.js"
import service from "../data/service/ServiceReducer"
import translatedResource from "../data/translated_resource/TranslatedResourceReducer"

export default combineReducers({
  app,
  appointment,
  classes,
  client,
  employee,
  service,
  translatedResource,
});
